import React from "react";
import { useHistory } from "react-router-dom";
import { Grid, Card, Typography } from "@mui/material";
import SuiBox from "components/SuiBox";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import Alert from "custom/Alert";

function SelectItemLetter() {
  const history = useHistory();

  const letters = [
    { value: "Aa", label: "Aa" },
    { value: "Bb", label: "Bb" },
    { value: "Cc", label: "Cc" },
    { value: "Çç", label: "Çç" },
    { value: "Dd", label: "Dd" },
    { value: "Ee", label: "Ee" },
    { value: "Ff", label: "Ff" },
    { value: "Gg", label: "Gg" },
    { value: "Ğğ", label: "Ğğ" },
    { value: "Hh", label: "Hh" },
    { value: "Iı", label: "Iı" },
    { value: "İi", label: "İi" },
    { value: "Jj", label: "Jj" },
    { value: "Kk", label: "Kk" },
    { value: "Ll", label: "Ll" },
    { value: "Mm", label: "Mm" },
    { value: "Nn", label: "Nn" },
    { value: "Oo", label: "Oo" },
    { value: "Öö", label: "Öö" },
    { value: "Pp", label: "Pp" },
    { value: "Rr", label: "Rr" },
    { value: "Ss", label: "Ss" },
    { value: "Şş", label: "Şş" },
    { value: "Tt", label: "Tt" },
    { value: "Uu", label: "Uu" },
    { value: "Üü", label: "Üü" },
    { value: "Vv", label: "Vv" },
    { value: "Yy", label: "Yy" },
    { value: "Zz", label: "Zz" },
  ];

  const handleLetterClick = (letter) => {
    history.push({
      pathname: "/sound-item/select-letter/new",
      state: { selectedLetter: letter },
    });
  };

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <Card>
            <SuiBox p={3}>
              <Typography variant="h5" fontWeight="bold" mb={3}>
                Ses Materyali Oluşturmak İçin Harf Seçin
              </Typography>
              <Typography variant="body2" color="text" mb={3}>
                Aşağıdaki harflerden birini seçtiğinizde, ses materyali oluşturma sayfasına
                yönlendirileceksiniz. Seçtiğiniz harf otomatik olarak ses alanında seçili gelecek ve
                değiştirilemeyecektir.
              </Typography>
              <Grid container spacing={2}>
                {letters.map((letter) => (
                  <Grid item xs={4} sm={3} md={2} key={letter.value}>
                    <SuiBox
                      p={2}
                      textAlign="center"
                      borderRadius="lg"
                      bgColor="white"
                      boxShadow="sm"
                      sx={{
                        cursor: "pointer",
                        transition: "all 0.2s ease-in-out",
                        border: "1px solid #d0d0d0",
                        backgroundColor: "rgba(52, 71, 103, 0.1)",
                        "&:hover": {
                          bgColor: "rgb(52, 71, 103)",
                          color: "white",
                          transform: "scale(1.05)",
                        },
                      }}
                      onClick={() => handleLetterClick(letter)}
                    >
                      <Typography variant="h6">{letter.label}</Typography>
                    </SuiBox>
                  </Grid>
                ))}
              </Grid>
            </SuiBox>
          </Card>
        </SuiBox>
      </DashboardLayout>
    </>
  );
}

export default SelectItemLetter;
